/** Balance below this uses warning styling (low agent credits). */
export const LOW_AVAILABLE_CREDITS_THRESHOLD = 100;

type Props = {
  balance: number | null;
  loading?: boolean;
  className?: string;
};

function formatCredits(n: number) {
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Prominent available-credits line for transaction forms (agent wallet).
 */
export default function AvailableCreditsCallout({ balance, loading = false, className = '' }: Props) {
  const hasNumber = balance != null && Number.isFinite(balance);
  const warn = hasNumber && balance! < LOW_AVAILABLE_CREDITS_THRESHOLD;

  let body: string;
  if (loading) body = 'Loading balance…';
  else if (hasNumber) body = `Available balance: ${formatCredits(balance!)} credits`;
  else body = 'Balance unavailable';

  const border = warn ? '#fed7aa' : hasNumber || loading ? '#bbf7d0' : '#e5e7eb';
  const background = warn ? '#fff7ed' : hasNumber || loading ? '#f0fdf4' : '#f9fafb';
  const textClass = warn ? 'text-amber-950' : hasNumber || loading ? 'text-emerald-950' : 'text-gray-600';

  return (
    <div
      role="status"
      aria-live="polite"
      className={`${textClass} ${className}`}
      style={{
        borderRadius: 8,
        padding: '10px 16px',
        fontSize: 14,
        fontWeight: 600,
        border: `1px solid ${border}`,
        background,
      }}
    >
      <span className="mr-1.5" aria-hidden>
        {warn ? '⚠️' : '💳'}
      </span>
      {body}
    </div>
  );
}
